// ── 출퇴근 관리 = [달력] [직원별 상세] 탭 화면 (2026-09-29 출퇴근 달력 합치기, 안 A) ──────
//   예전 두 메뉴(출퇴근 관리·출퇴근 달력)를 한 메뉴로. 각 탭은 원래 화면을 **그대로** 그린다 —
//   화면이 제목 줄은 그대로 그리고, 제목 아래에 이 탭 버튼(tabSlot)을 끼워 넣는다.
//   지금 탭은 주소의 ?view=calendar|detail 로 기억한다(새로고침·뒤로가기·예전 주소 넘겨주기가 같은 길).
//   달력은 한 번 열었으면 상세 탭에 가 있는 동안 **숨겨서 남겨 둔다** — 이름을 눌러 상세로 갔다가
//   뒤로 오면 보던 달·거르기가 그대로다(다시 그리면 이번 달로 돌아갔다 — 검토에서 발견).
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AttendanceTabBar from './AttendanceTabBar';
import { pickTab, HUB_TITLE, HUB_SUBTITLE } from './attendanceTabs';

/**
 * @param {string[]} tabs            열 수 있는 탭(attendanceTabs.js 가 열쇠로 정한다)
 * @param {(p)=>ReactNode} renderCalendar  달력 탭 화면. p = { title, subtitle, tabSlot, onPickPerson, withTools, reloadSignal }
 * @param {(p)=>ReactNode} renderDetail    직원별 상세 탭 화면. p = { title, subtitle, tabSlot, initialUserId, initialYm, onDataChanged }
 */
export default function AttendanceHub({ tabs, renderCalendar, renderDetail }) {
  const [params, setParams] = useSearchParams();
  const active = pickTab(tabs, params.get('view'));
  const [calendarSeen, setCalendarSeen] = useState(active === 'calendar');
  useEffect(() => { if (active === 'calendar') setCalendarSeen(true); }, [active]);
  // 상세 탭에서 기록·예외 스케줄을 저장하면 숫자를 올려 숨겨 둔 달력도 다시 불러오게 한다
  const [calendarReload, setCalendarReload] = useState(0);

  if (!active) {
    // 열쇠가 하나도 없음 — 메뉴에도 안 뜨지만 주소를 직접 친 경우(서버도 막는다)
    return (
      <div style={{ padding: 32, textAlign: 'center', color: 'var(--text-muted)' }}>
        출퇴근 관리 권한이 없습니다.
      </div>
    );
  }

  // 탭을 눌러 옮기면 고른 직원·달은 버린다(그 탭의 처음 모습).
  const tabSlot = <AttendanceTabBar tabs={tabs} active={active} onChange={(key) => setParams({ view: key })} />;
  const common = { title: HUB_TITLE, subtitle: HUB_SUBTITLE, tabSlot };
  const onCalendar = active === 'calendar';
  // 달력의 이름 칩 → 직원별 상세 탭(그 사람·그 달). 상세 탭 열쇠가 없으면 칩은 예전처럼 날짜 상세만.
  const onPickPerson = tabs.includes('detail')
    ? (userId, ymd) => setParams({ view: 'detail', user: String(userId), ym: String(ymd || '').slice(0, 7) })
    : undefined;

  return (
    <>
      {tabs.includes('calendar') && (onCalendar || calendarSeen) && (
        <div style={{ display: onCalendar ? 'block' : 'none' }}>
          {/* withTools: [엑셀][시간 설정]은 상세 탭 열쇠가 있을 때만(그 서버 기능이 출퇴근 관리 열쇠를 본다) */}
          {renderCalendar({ ...common, onPickPerson, withTools: tabs.includes('detail'), reloadSignal: calendarReload })}
        </div>
      )}
      {!onCalendar && renderDetail({
        ...common, initialUserId: params.get('user'), initialYm: params.get('ym'),
        onDataChanged: () => setCalendarReload((n) => n + 1),
      })}
    </>
  );
}
